import FetchHelper from '../helpers/fetch_helper';
import AuthHelper from '../helpers/auth_helper';
import auth_helper from '../helpers/auth_helper';
import LocalStorageHelper from '../helpers/local_storage_helper';
import SessionStorageHelper from '../helpers/session_storage_helper';
import LocationHelper from '../helpers/location_helper';
import Actions from '../actions/actions';
import FunctionalityAccessHelper from '../helpers/functionality_access_helper';

const AuthenticationDispatcher = {
  async logIn({ username, password, at }) {
    const options = {
      headers: {
        authorization: 'Basic ' + btoa('anubis:A563CA831B3A13681D744AD3D6D526'),
        accept: 'application/json',
      },
      method: 'POST',
      body: {
        grant_type: 'password',
        scope: 'write',
        username: username,
        password: password,
      },
    };

    try {
      const oauthResponse = await FetchHelper.fetchJson('oauth/token', options);
      AuthHelper.setSessionCookie(oauthResponse.access_token, oauthResponse.expires_in);

      if (LocationHelper.searchAsObj().redirectUrl) {
        window.location.href = LocationHelper.searchAsObj().redirectUrl;
      }

      await this.dispatch({ type: 'fetchAuthenticatedUser' });

      Actions.setIsFreshlyLoggedIn(true);
      const user = this.getStoreVal('user');
      const impersonatedUser = AuthHelper.getImpersonateCookie();
      if (
        at &&
        !at.includes('/login') &&
        !at.endsWith('/') &&
        !at.endsWith('.net') &&
        !at.lastIndexOf('.net:3000') &&
        !at.endsWith('.com')
      ) {
        window.location.href = at;
      } else if (user.atype === 'CPF' && !impersonatedUser) {
        this.dispatch({ type: 'setRoute', data: '/admin' });
      } else if (impersonatedUser) {
        this.dispatch({ type: 'setRoute', data: '/customers' });
      } else if (oauthResponse?.responseCode === 426) {
        await Actions.setIsFreshlyLoggedIn(null);
      } else if (
        FunctionalityAccessHelper.getUserSettingValueByName('is_training_required', user) === 'true' &&
        !user?.userAgreementComp
      ) {
        this.dispatch({ type: 'setRoute', data: '/training-required' });
      } else {
        this.dispatch({ type: 'setRoute', data: '/proposal/new' });
      }
    } catch (error) {
      this.dispatch({ type: 'setErrorMessages', data: ['Invalid credentials'] });
      this.dispatch({ type: 'setRoute', data: '/login' });
      throw new Error('Invalid credentials');
    }
  },

  async logOut({ timedOut } = {}) {
    const currentLocation = window.location.pathname;
    this.dispatch({ type: 'logOutUser' });

    // if user is impersonating, delete the impersonate cookie and set the user store back to their user
    // otherwise, end session
    const impersonatedUserId = AuthHelper.getImpersonateCookie();
    // console.log('impersonatedUserId', impersonatedUserId);
    if (impersonatedUserId) {
      const impersonationType = AuthHelper.removeImpersonation();
      if (AuthHelper.getCognitoCookie()) {
        window.close();
      }
      try {
        if (AuthHelper.getSessionToken() || AuthHelper.isUWImpersonating()) {
          Actions.fetchAuthenticatedUser();
          Actions.fetchUserList({ isActive: true, coid: null });
          await this.dispatch({ type: 'fetchAuthenticatedUser' });

          let desiredLocation = '/account/users';
          if (impersonationType === 'session') {
            desiredLocation = currentLocation === '/customers' ? '/' : currentLocation;
          }
          this.dispatch({ type: 'setRoute', data: desiredLocation });

          const message = 'You are no longer impersonating';
          this.dispatch({ type: 'setMessages', data: [message] });
        } else if (AuthHelper.getCognitoCookie()) {
          window.location.href = LocationHelper.getUrlForSubdomain('uw');
        } else {
          this.dispatch({ type: 'setRoute', data: '/login' });
        }
      } catch (error) {
        if (error) {
          console.error(error);
        }
        AuthHelper.deleteSession(this.getStoreVal('user')?.userid);
        this.dispatch({ type: 'setErrorMessages', data: ['Unable to access parent user'] });
        this.dispatch({ type: 'setRoute', data: '/login' });
        throw new Error('Invalid credentials');
      }
    } else {
      AuthHelper.deleteSession(this.getStoreVal('user')?.userid);
      this.dispatch({ type: 'setRoute', data: '/login' });
      const message = timedOut ? 'Your session has timed out.' : 'You have been successfully logged out.';
      this.dispatch({ type: 'setMessages', data: [message] });
    }
  },

  async deleteAuthToken() {
    return await FetchHelper.fetchJson('users/logout', {
      method: 'POST',
      body: { revokeMFA: false },
    });
  },

  async logOutUser() {
    const impersonatedUser = AuthHelper.getImpersonateCookie();
    this.dispatch({ type: 'clearPolling' });
    if (!impersonatedUser) {
      this.resetStore();
      // this.dispatch({ type: 'deleteAuthToken' });
      AuthHelper.deleteP2Cookie();
      LocalStorageHelper.clearAllData();
      SessionStorageHelper.clearAllData();
    } else {
      return this.dispatch({ type: 'setRoute', data: `/account/standby/logout` });
    }
  },

  async fetchAuthenticatedUser() {
    try {
      let userStoreval;

      const getUsersResponse = await FetchHelper.fetchJson('users/current', { method: 'get', oauth: true });

      userStoreval = getUsersResponse.results[0];

      // Send user id & company name to google analytics
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        userId: userStoreval.userid,
        companyName: userStoreval.company.name,
      });

      // if (userStoreval.atype !== 'CPF') await this.dispatch({ type: 'fetchUserPreferredEmail' });

      await this.dispatch({ type: 'fetchUserSettingValues', data: userStoreval.userid });

      const impersonatedUser = AuthHelper.getImpersonateCookie();
      if (impersonatedUser) {
        const impersonatedUserResponse = await FetchHelper.fetchJson('users/impersonated-user', {
          method: 'get',
          oauth: false,
        });
        userStoreval = impersonatedUserResponse.results[0];
      }
      // if (!userStoreval.userAgreementComp) {
      //   const getUserAgreementComp = await FetchHelper.fetchJson('users/user-agreement/', {
      //     method: 'get',
      //     oauth: true
      //   });
      //
      //   userStoreval.userAgreementComp = getUserAgreementComp.results[0].userAgreementComp;
      // }
      let billBeforeAgree = false;
      let contains1GuestSetting = false;

      userStoreval.userSettingValues.forEach(({ setting, value }) => {
        billBeforeAgree = billBeforeAgree || (setting === 'bill-before-agree' && value === '1');
        contains1GuestSetting = contains1GuestSetting || (setting === 'cpf-guest' && value === '1');
      });

      const isGuestUser = contains1GuestSetting && userStoreval.atype === 'U';

      this.setStoreVal('isGuestUser', isGuestUser);
      this.setStoreVal('billBeforeAgree', billBeforeAgree);

      this.setStoreVal('user', userStoreval);

      if (window.location.host.indexOf('uw') === 0) {
        return;
      }
      return await this.dispatch({ type: 'fetchFunctionalityAcls', data: userStoreval.userid });
    } catch (error) {
      if (error?.response?.status === 401) {
        auth_helper.deleteSession(this.getStoreVal('user')?.userid);
        auth_helper.deleteP2Cookie();
        this.setStoreVal('user', [{}]);
        this.dispatch({ type: 'setRoute', data: '/login' });
        return this.dispatch({ type: 'setView', data: { page: 'login' } });
      } else {
        return this.dispatch({
          type: 'handleRequestError',
          data: { error, defaultErrorMessage: 'Failed to fetch user' },
        });
      }
    }
  },

  async impersonateUser({ userid, username, name, goto, url, bySession }) {
    if (goto) {
      this.dispatch({ type: 'setRoute', data: `/account/standby?name=${name}` });
      this.dispatch({ type: 'clearPolling' });
    }

    const experation = 60 * 60;
    if (bySession) {
      sessionStorage.setItem('impersonation', btoa(`${userid}:${username}`));
      window.location.reload();
    } else {
      AuthHelper.setImpersonateCookie(btoa(`${userid}:${username}`), experation);
    }

    // Actions.fetchUserList({ isActive: true, coid: null });
    if (goto) {
      await this.dispatch({ type: 'fetchAuthenticatedUser' });
      this.dispatch({ type: 'setRoute', data: goto });
    }
    if (url) {
      let child = window.open(url, '_blank');
      child.focus();
    }
  },

  async impersonateCustomerOwner({ customerId, bySession = true, goto, url }) {
    const installer =
      LocationHelper.getSubdomainFromUrl() === 'uw'
        ? await Actions.fetchDecisionUserByCustomer(customerId)
        : await Actions.fetchUserByCustomer(customerId);
    this.dispatch({
      type: 'impersonateUser',
      data: {
        userid: installer.userid,
        username: installer.username,
        name: `${installer.firstname} ${installer.lastname}`,
        bySession: bySession,
        goto: goto,
        url: url,
      },
    });
  },

  async userAgreesTermsOfUse() {
    try {
      const usersResponse = await FetchHelper.fetchJson('users', {
        method: 'put',
        body: { userAgreementComp: true },
      });
      const user = usersResponse.results[0];
      this.setStoreVal('user', user);
      this.dispatch({ type: 'setRoute', data: '/proposal/new' });
      LocalStorageHelper.setData('user', JSON.stringify(user));
    } catch (error) {
      this.dispatch({ type: 'handleRequestError', data: { error, defaultErrorMessage: 'Failed to update user' } });
    }
  },

  async saveUserPreferredEmail(email) {
    try {
      const promise = await FetchHelper.fetchJson('users/email-preferences', {
        method: 'POST',
        body: {
          preferredEmailAddress: email,
        },
      });
      this.setStoreVal('userPreferredEmail', promise.results[0].preferredEmailAddress);
      SessionStorageHelper.setDataInSession('userPreferredEmail', promise.results[0].preferredEmailAddress);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: "Failed to save user's preferred email address" },
      });
    }
  },

  async fetchUserPreferredEmail() {
    try {
      // check session storage first
      let preferredEmail = SessionStorageHelper.getDataFromSession('userPreferredEmail');
      // if not found in session storage, ask server
      if (preferredEmail === null || preferredEmail === undefined) {
        const response = await FetchHelper.fetchJson('users/email-preferences', { method: 'GET' });
        if (response.count > 0) {
          preferredEmail = response.results[0].preferredEmailAddress;
          this.setStoreVal('userPreferredEmail', preferredEmail);
          SessionStorageHelper.setDataInSession('userPreferredEmail', preferredEmail);
        }
      }
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: "Failed to retrieve user's preferred email address" },
      });
    }
  },

  setInlineManualUserTracking(user) {
    let roles = [user.atype];
    let group = user.company.name;
    let plan = 'Solar';
    let eeEnabled = false;
    let solarEnabled = false;

    if (user.opsMgr) {
      roles.push('opsMgr');
    }
    if (user.branchmgr) {
      roles.push('branchmgr');
    }
    if (user.branch.branchname) {
      group = group + ': ' + user.branch.branchname;
    }

    user.products.forEach((product) => {
      if (product.productSku === 'ELOAN_001' || product.productSku === 'EPACE_001') {
        eeEnabled = true;
      } else {
        solarEnabled = true;
      }
    });

    if (eeEnabled && solarEnabled) {
      plan = 'SolarEE';
    } else if (eeEnabled) {
      plan = 'EE';
    } else if (solarEnabled) {
      plan = 'Solar';
    } else {
      plan = 'none';
    }

    const inlineUserData = {
      uid: user.id,
      username: user.firstname + ' ' + user.lastname,
      name: user.firstname + ' ' + user.lastname,
      roles: roles,
      group: group,
      plan: plan,
    };

    window.inlineManualTracking = inlineUserData;
    if (!window.inline_manual_player) {
      /* eslint-disable no-undef */
      createInlineManualPlayer(window.inlineManualPlayerData);
      /* eslint-enable no-undef */
    } else {
      window.inline_manual_player.setMetadata({ uid: inlineUserData.uid });
      window.inline_manual_player.updateProfile(inlineUserData);
    }
  },

  async signUp(data) {
    return await FetchHelper.fetchJson('users/sign-up', { method: 'POST', body: data });
  },

  async guestAuth() {
    let guestSession = await FetchHelper.fetchJson('users/guest-oauth', { method: 'GET' });

    if (guestSession) {
      AuthHelper.setGuestToken(guestSession);
    }

    return guestSession;
  },

  async fetchGuestResumeUrl(data) {
    const response = await FetchHelper.fetchJson('users/resume/url', {
      method: 'post',
      body: data,
    });

    return response;
  },

  async askForResumeApplicationEmail(data) {
    return await FetchHelper.fetchJson('users/resume/email', { method: 'POST', body: data });
  },

  async askForResumeTokenInfo(data) {
    return await FetchHelper.fetchJson(`users/resume/${data}/info`, { method: 'GET' });
  },

  async askForResumeApplicationSession(data) {
    try {
      AuthHelper.startGuestSession();
      return await FetchHelper.fetchJson('users/resume/continue', { method: 'POST', body: data });
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error: null, defaultErrorMessage: 'Email address does not match, please try again.' },
      });
      throw error;
    }
  },

  async getGenericMarketingUrl() {
    let user = this.getStoreVal('user');
    let companyName = user.companyName ? user.companyName : user?.company?.name;
    let installerName = user?.firstname + ' ' + user?.lastname;
    let resumeAppToken = user?.resumeAppTokenCaptcha;
    let isTest = user?.company?.isTest;

    if (isTest) {
      resumeAppToken = user?.resumeAppTokenNoCaptcha;
    }

    if (!resumeAppToken) {
      return Actions.setErrorMessages([`This user cannot currently share quickcheck links`]);
    }

    return (
      await FetchHelper.fetchJson('short-url', {
        method: 'POST',
        body: {
          url:
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') +
            `/?auth=${resumeAppToken}&companyName=${companyName}&installerName=${installerName}&captcha=${!isTest}`,
          purpose: 'GENERIC_MARKETING',
        },
      })
    ).results[0];
  },

  async getIndividualMarketingUrl({ cfirstname, clastname, cemail }) {
    let user = this.getStoreVal('user');
    let companyName = user?.company?.name;
    let installerName = user?.firstname + ' ' + user?.lastname;
    let resumeAppToken = user?.resumeAppTokenNoCaptcha;

    if (!resumeAppToken) {
      return Actions.setErrorMessages([`This user cannot currently share quickcheck links`]);
    }

    let result = (
      await FetchHelper.fetchJson('customers/prescreen/via_email', {
        method: 'POST',
        body: {
          cfirstname,
          clastname,
          cemail,
          url:
            window.location.protocol +
            '//' +
            window.location.hostname +
            (window.location.port ? ':' + window.location.port : '') +
            `/?auth=${resumeAppToken}&cfirstname=${cfirstname}&clastname=${clastname}&cemail=${cemail}&companyName=${companyName}&installerName=${installerName}&captcha=false`,
        },
      })
    ).results[0];
    this.setStoreVal('IndividualMarketingUrl', result);
    return result;
  },

  async setRecaptchaToken({ token }) {
    this.setStoreVal('recaptchaToken', token);
  },

  // ------------------------------------------------------------setup auth
  async registerNewMFADevice({ userId, type }) {
    userId = userId ? userId : this.getStoreVal('user')?.id;
    const response = await FetchHelper.fetchJson(`users/${userId}/mfas/${type}/register/challenge`, {
      method: 'POST',
      body: {},
    });
    this.setStoreVal('mfaTokenResponse', response);
    return response;
  },

  async registerNewMFADeviceValidate({ userId, type, token }) {
    userId = userId ? userId : this.getStoreVal('user')?.id;
    return await FetchHelper.fetchJson(`users/${userId}/mfas/${type}/register/validate`, {
      method: 'POST',
      body: {
        code: token,
      },
    });
  },

  async editMobilePhone({ userId, mobilePhone }) {
    userId = userId ?? this.getStoreVal('user')?.id;
    return await FetchHelper.fetchJson(`users/${userId}/profile`, {
      method: 'PATCH',
      body: { mobilePhone: mobilePhone ? `1${mobilePhone}` : null },
    });
  },

  // ------------------------------------------------------------using mfa auth
  async sendMFARequest({ userId, type }) {
    userId = userId ? userId : this.getStoreVal('user')?.id;
    const response = await FetchHelper.fetchJson(`users/${userId}/mfas/${type}/challenge`, {
      method: 'POST',
    });

    this.setStoreVal('mfaTokenResponse', response);
    return response;
  },

  async validateMFARequest({ userId, type, token }) {
    userId = userId ? userId : this.getStoreVal('user')?.id;
    return await FetchHelper.fetchJson(`users/${userId}/mfas/${type}/validate`, {
      method: 'POST',
      body: { code: token },
    });
  },

  //for user admin MFA management
  //------------------------------------------------------------user-admin
  // async getMFASessions() {
  //   console.log('getMFASessions');
  //   //GET: users/{userId}/mfas/{type}/sessions v1
  // },
  //
  // async getMFADevices() {
  //   console.log('getMFADevices');
  //   //GET: users/{userId}/mfas/devices v1
  // },
  //
  async removeMFADevice({ userId, type }) {
    userId = userId ? userId : this.getStoreVal('user')?.id;
    return await FetchHelper.fetchJson(`users/${userId}/mfas/${type}`, {
      method: 'DELETE',
    });
  },
  //
  // async revokeMFASession() {
  //   console.log('revokeMFASession');
  //   //DELETE: users/{userId}/mfas/{type}/sessions/{sessionId} v1
  // },

  getIsFreshlyLoggedIn() {
    return this.getStoreVal('freshlyLoggedIn');
  },
  setIsFreshlyLoggedIn(data) {
    return this.setStoreVal('freshlyLoggedIn', data);
  },
};
export default AuthenticationDispatcher;
